<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-user"></i> 儿童管理</span>
      </div>

      <!-- Tab切换 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all">
          <all-children v-if="activeTab === 'all'"></all-children>
        </el-tab-pane>
        <!-- <el-tab-pane label="毕业" name="graduate">
          <graduate-children v-if="activeTab === 'graduate'"></graduate-children>
        </el-tab-pane> -->
      </el-tabs>
    </el-card>
  </div>
</template>


<script>
import AllChildren from './AllChildren.vue';
import GraduateChildren from './GraduateChildren.vue';

export default {
  components: {
    AllChildren,
    GraduateChildren
  },
  data() {
    return {
      activeTab: "all"
    };
  },
  methods: {
    handleTabClick(tab) {
      this.activeTab = tab.name;
    }
  }
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>

<style scoped>
.custom-dialog >>> .el-dialog {
  margin-top: 20px !important; /* 控制弹窗距离顶部位置 */
  max-height: 90vh;
  overflow-y: auto;
}
</style>
